import React, { useState } from 'react';
import { Button, Form, Row, Col, Table, Container } from 'react-bootstrap';
import { NumberFormatBase, NumericFormat } from 'react-number-format'; // Corrigido para importar NumericFormat
import './index.css';
import { MaskedNumber } from 'imask';
import PhoneInput from 'react-phone-number-input/input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheck,
    faLightbulb,
    faPhone,
} from '@fortawesome/free-solid-svg-icons';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import GradientProgressBar from './ProgressBar/ProgressBar';

const CalculadoraRPA = () => {
    const [dados, setDados] = useState({
        ramoAtividade: '',
        dataAbertura: '',
        faturamento_1: '',
        faturamento_2: '',
    });

    const [resultados, setResultados] = useState({
        dentroDoLimiteAnoPassado: false,
        faturamentoPrevisto: 0,
        ultrapassouLimite: false,
        porcentagemUltrapassagem: 0,
    });

    const [step, setStep] = useState('calculadora');
    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDados({ ...dados, [name]: value });
    };

    const handleCalculate = async () => {
        if (
            dados.ramoAtividade.length > 0 &&
            dados.dataAbertura.length > 0 &&
            dados.faturamento_1.length > 0 &&
            dados.faturamento_2.length > 0
        ) {
            // await sendEmail();
            calculate();
            setStep('resultado');
        } else {
            alert('Preencha todos os campos para gerar o resultado!');
        }
    };

    const calculate = () => {
        const limiteMEI = 81000; // Limite anual do MEI em reais
        const { faturamento_1, faturamento_2 } = dados;

        // Função para remover "R$" e separar corretamente os valores numéricos
        const limparNumero = (valor) => {
            if (!valor) return 0;
            return parseFloat(valor.replace(/[^0-9,]/g, '').replace(',', '.'));
        };

        // Converter os valores corretamente
        const faturamentoAnoPassado = limparNumero(faturamento_1);
        const faturamentoAnoAtual = limparNumero(faturamento_2);

        // Verificar se o faturamento do ano passado ficou dentro do limite
        const dentroDoLimiteAnoPassado = faturamentoAnoPassado <= limiteMEI;

        // Obter o mês atual
        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1; // Janeiro = 0, então somamos 1

        // Garantir que o faturamento atual seja válido antes de projetar
        let faturamentoPrevisto = 0;
        let ultrapassouLimite = false;
        let porcentagemUltrapassagem = 0;

        if (mesAtual > 0) {
            // Previsão de faturamento proporcional ao ano inteiro
            faturamentoPrevisto = (faturamentoAnoAtual / mesAtual) * 12;

            // Verificar se ultrapassa o limite do MEI
            if (faturamentoPrevisto > limiteMEI) {
                ultrapassouLimite = true;
                porcentagemUltrapassagem =
                    ((faturamentoPrevisto - limiteMEI) / limiteMEI) * 100;
            }
        }

        setResultados({
            dentroDoLimiteAnoPassado: dentroDoLimiteAnoPassado,
            faturamentoPrevisto: faturamentoPrevisto,
            ultrapassouLimite: ultrapassouLimite,
            porcentagemUltrapassagem: porcentagemUltrapassagem,
        });

        return {
            dentroDoLimiteAnoPassado,
            faturamentoPrevisto: faturamentoPrevisto
                ? faturamentoPrevisto.toFixed(2)
                : null,
            ultrapassouLimite,
            porcentagemUltrapassagem: ultrapassouLimite
                ? porcentagemUltrapassagem.toFixed(2)
                : 0,
        };
    };

    const sendEmail = async () => {
        const url =
            'http://apiemail.bckcode.com.br/api_email/public/api/send-mail';

        let body = '<h1>Novo cálculo RPA realizado!</h1><br>';
        body += `<strong>Nome</strong>: ${dados.nome}<br>`;
        body += `<strong>Email</strong>: ${dados.email}<br>`;
        body += `<strong>Telefone</strong>: ${dados.telefone}<br>`;
        body += `<strong>Tipo Contrato</strong>: ${dados.tipoContrato}<br>`;
        body += `<strong>Atividade</strong>: ${dados.atividade}<br>`;
        body += `<strong>Ganho Bruto</strong>: ${formatarParaReal(
            parseFloat(dados.ganhoBruto)
        )}<br>`;

        const emailData = {
            corpo: body,
            assunto: 'Novo cálculo RPA realizado!',
            para: 'contato@contabilidadeolimpia.com.br',
            de: 'webservices@splbeneficios.com',
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(emailData),
            });

            if (!response.ok) {
                throw new Error('Erro ao enviar o email');
            }

            const result = await response.json();
            setStatus('Email enviado com sucesso!');
            console.log(result);
        } catch (error) {
            setStatus(`Falha ao enviar email: ${error.message}`);
        }
    };

    function formatarParaReal(valor) {
        return valor.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
    }

    const currencyMask = createNumberMask({
        prefix: 'R$ ',
        thousandsSeparatorSymbol: '.',
        decimalSymbol: ',',
        allowDecimal: true,
        includeThousandsSeparator: true,
        allowNegative: false,
        integerLimit: 10,
        decimalLimit: 2,
    });

    return (
        <>
            <Row style={{ marginBottom: '150px' }}>
                <Col sm={12} md={12} lg={8}>
                    <div className="main">
                        <div className="container mt-4 pt-3">
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                                className="mb-5"
                            >
                                <img
                                    src="https://www.contabilidadeolimpia.com.br/wp-content/uploads/2022/05/logo-contabilidade-olimpia-transparente.png"
                                    width={250}
                                />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    boxSizing: 'border-box',
                                }}
                            >
                                <h2
                                    className="mt-2 text-center mb-2"
                                    style={{
                                        color: '#002868',
                                        marginTop: '15px',
                                        fontSize: '24px', // Tamanho da fonte ajustado
                                    }}
                                >
                                    Desenquadrar MEI para ME
                                </h2>
                                <p
                                    className="mt-2 text-center mb-5"
                                    style={{
                                        maxWidth: 500,
                                        fontSize: '16px',
                                        lineHeight: '1.5',
                                    }}
                                >
                                    Faça o cálculo do seu faturamento anual e
                                    veja se você precisa se desenquadrar ou não
                                    do MEI.
                                </p>
                            </div>

                            <Form className="text-center">
                                <Row>
                                    <Col md={6}>
                                        <Form.Group controlId="tipoContrato">
                                            <Form.Label>
                                                Ramo de atividade da sua
                                                empresa*
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                as="select"
                                                name="ramoAtividade"
                                                value={dados.ramoAtividade}
                                                onChange={handleChange}
                                            >
                                                <option value="">
                                                    Selecione
                                                </option>
                                                <option value="serviço">
                                                    Serviço
                                                </option>
                                                <option value="comercio">
                                                    Comércio
                                                </option>
                                                <option value="servico/comercio">
                                                    Serviço e Comércio
                                                </option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="data-abertura">
                                            <Form.Label>
                                                Data de Abertura do seu MEI*
                                            </Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="dataAbertura"
                                                value={dados.dataAbertura}
                                                onChange={handleChange}
                                                placeholder="Selecione a data de abertura do seu MEI"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={6}>
                                        <Form.Group controlId="faturamento_1">
                                            <Form.Label>
                                                Faturamento acumulado em 2024*
                                            </Form.Label>
                                            <MaskedInput
                                                className="form-control"
                                                mask={currencyMask}
                                                value={dados.faturamento_1}
                                                onChange={handleChange}
                                                placeholder="R$ 0,00"
                                                name="faturamento_1"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="faturamento_2">
                                            <Form.Label>
                                                Faturamento acumulado em 2025*
                                            </Form.Label>
                                            <MaskedInput
                                                className="form-control"
                                                mask={currencyMask}
                                                value={dados.faturamento_2}
                                                onChange={handleChange}
                                                placeholder="R$ 0,00"
                                                name="faturamento_2"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3 text-center">
                                    <Col md={12}>
                                        <Button
                                            style={{ width: '50%' }}
                                            onClick={handleCalculate}
                                        >
                                            Gerar Resultado
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>

                            {step === 'resultado' && (
                                <>
                                    <Row
                                        className="mt-5"
                                        style={{ padding: '15px' }}
                                    >
                                        <h2 style={{ textAlign: 'center' }}>
                                            Está na hora de me desenquadrar do
                                            MEI?
                                        </h2>
                                    </Row>

                                    <Row className="mt-5">
                                        <Col md={12}>
                                        <p>
                                                    <b>Ano passado</b>:
                                                    {(resultados.dentroDoLimiteAnoPassado && (
                                                        <>
                                                            Sua empresa
                                                            permaneceu dentro do
                                                            limite permitido.
                                                        </>
                                                    )) || (
                                                        <>
                                                            Sua empresa excedeu
                                                            o limite permitido
                                                            de faturamento.
                                                        </>
                                                    )}
                                                </p>
                                                <p>
                                                    <b>Esse ano</b>:
                                                    {(resultados.porcentagemUltrapassagem >
                                                        0 && (
                                                        <>
                                                            De acordo com o
                                                            faturamento
                                                            proporcional
                                                            acumulado até esse
                                                            momento, a previsão
                                                            é que sia empresa
                                                            ultrapasse o limite
                                                            do MEI em
                                                            aproximadamente{' '}
                                                            {resultados.porcentagemUltrapassagem.toFixed(
                                                                2
                                                            )}
                                                            %, superior a{' '}
                                                            {formatarParaReal(
                                                                resultados.faturamentoPrevisto
                                                            )}
                                                        </>
                                                    )) || (
                                                        <>
                                                            O Faturamento
                                                            aculolado desse ano
                                                            ainda permite que
                                                            sua empresa seja
                                                            MEI.
                                                        </>
                                                    )}
                                                </p>

                                            <GradientProgressBar
                                                value={
                                                    resultados.porcentagemUltrapassagem
                                                }
                                                txtValue={
                                                    resultados.porcentagemUltrapassagem >
                                                    100
                                                        ? 100
                                                        : resultados.porcentagemUltrapassagem
                                                }
                                            />

<p>
                                                    Se sua empresa no ano
                                                    passado se manteve dentro do
                                                    limite de faturamento
                                                    permitido para MEI e a
                                                    porcentagem de ultrapassagem
                                                    prevista inferior a 20%, sua
                                                    empresa ainda pode continuar
                                                    atuando como MEI.
                                                </p>
                                                <p>
                                                    Caso contrário, sua empresa
                                                    deve se desvincular do MEI.
                                                    Entre em contato conosco
                                                    para que possamos auxiliar
                                                    sua empresa rumo ao
                                                    crescimento!
                                                </p>
                                                <p>
                                                    <a
                                                        href="https://www.contabilidadeolimpia.com.br/faleconoscocontato/"
                                                        target="_blank"
                                                    >
                                                        Clique aqui para entrar
                                                        em contato conosco!
                                                    </a>
                                                </p>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </div>
                    </div>
                </Col>
                <Col sm={12} md={12} lg={4} style={{ marginBottom: '25px' }}>
                    <div
                        className="card main shadow-lg p-4 rounded custom-gradient"
                        style={{
                            background:
                                'linear-gradient(to bottom, #7cceee, #ffffff)',
                        }}
                    >
                        <h1>Abra seu CNPJ grátis com a Olímpia!</h1>
                        <div>
                            <p
                                className="text-center"
                                style={{
                                    marginBottom: '-10px',
                                    fontWeight: 600,
                                }}
                            >
                                Pague
                            </p>
                            <span
                                className="text-center"
                                style={{ fontSize: '40px', fontWeight: 700 }}
                            >
                                {' '}
                                SÓ AS TAXAS
                            </span>
                        </div>
                        <a
                            href="https://api.whatsapp.com/send?phone=5511968591004&text=Gostaria%20de%20abrir%20meu%20CNPJ"
                            style={{ marginTop: '20px', width: '100%' }}
                            target="_blank"
                            className="btn btn-primary"
                        >
                            QUERO SER PJ
                        </a>
                        <ul
                            style={{
                                listStyle: 'none',
                                textAlign: 'left',
                                marginTop: '20px',
                            }}
                        >
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Contratando um de nossos planos de
                                contabilidade,{' '}
                                <b>a abertura do seu CNPJ é grátis</b>
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                <b>Otimizamos os impostos</b> do seu CNPJ para a
                                sua remuneração render.
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Emita notas fiscais e acompanhe sua empresa{' '}
                                <b>24h por dia</b> na nossa plataforma
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Escolha a forma de atendimento:{' '}
                                <b>WhatsApp, telefone, chat ou e-mail</b>
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                <b>Planos com assessor que entende sua área</b>{' '}
                                e emite suas notas fiscais
                            </li>
                            {/* <li style={{marginTop: '3px'}}><FontAwesomeIcon icon={faCheck} color="#1b93c3" size={25}/> Contrate <b>planos de saúde até 30% mais baratos do que os para pessoa física</b></li> */}
                        </ul>
                    </div>
                </Col>
            </Row>

            <div className="bottom-cta-area">
                <div className="container">
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div className="container container-cust">
                                <div style={{ display: 'flex' }}>
                                    <div
                                        className="hide-mobile"
                                        style={{ width: 100 }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faLightbulb}
                                            color="#1b93c3"
                                            size="3x"
                                        />
                                    </div>
                                    <div
                                        className="hide-mobile"
                                        style={{
                                            textAlign: 'left',
                                            width: 200,
                                            color: '#414141',
                                        }}
                                    >
                                        Acessoria especializada no seu
                                        seguimento
                                    </div>
                                    <div
                                        className="cta-btn-area"
                                        style={{
                                            display: 'flex',
                                            flex: 2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <a
                                            target="_blank"
                                            href="https://www.contabilidadeolimpia.com.br/faleconoscocontato#nossos-planos"
                                            style={{
                                                fontWeight: 700,
                                                color: '#1b93c3',
                                                borderWidth: '0.5px',
                                                borderColor: '#1b93c3',
                                                borderStyle: 'solid',
                                                padding: '10px 30px',
                                                borderRadius: 25,
                                            }}
                                        >
                                            Conheça nossos planos
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div className="container container-cust">
                                <div style={{ display: 'flex' }}>
                                    <div
                                        className="hide-mobile"
                                        style={{ width: 100 }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPhone}
                                            color="#1b93c3"
                                            size="3x"
                                        />
                                    </div>
                                    <div
                                        className="hide-mobile"
                                        style={{
                                            textAlign: 'left',
                                            width: 200,
                                            color: '#414141',
                                        }}
                                    >
                                        <span style={{ fontWeight: 600 }}>
                                            Dúvidas?
                                        </span>
                                        <br />
                                        Entre em contato
                                    </div>
                                    <div
                                        className="cta-btn-area"
                                        style={{
                                            display: 'flex',
                                            flex: 2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <a
                                            href="https://www.contabilidadeolimpia.com.br/faleconoscocontato/"
                                            target="_blank"
                                            style={{
                                                fontWeight: 700,
                                                color: '#fff',
                                                borderWidth: '0.5px',
                                                background: '#1b93c3',
                                                borderStyle: 'solid',
                                                padding: '10px 30px',
                                                borderRadius: 25,
                                            }}
                                        >
                                            Fale com um especialista
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default CalculadoraRPA;
